<template>
  <ProcessPreview :processID="processID" :version="version" :params="params" />
</template>
<script>
import ProcessPreview from '@/components/Process/ProcessPreview.vue';
import { vueBasedDefaultProcessRunnerVersion } from '@/utils/constants/WorkFlowConstants.js';

export default {
  name: 'Process',
  data() {
    return {
      version: null,
      processID: null,
      params: null,
    };
  },
  async created() {
    let formParams = new URLSearchParams(this.$route.query).toString();

    this.version =
      this.$route.params.version || vueBasedDefaultProcessRunnerVersion;
    this.processID = this.$route.params.processID || null;
    this.params = formParams;
  },

  components: {
    ProcessPreview,
  },
};
</script>
